/* Fiori - editorial product carousel
   Scroll-snap track with arrows + progress bar, and an inline size row that
   adds to cart via the ajax cart without leaving the page.
   Shared by sections/fiori-product-carousel, sections/fiori-editorial-carousel
   and the product-page mode of sections/featured-collection. */

(function () {
  function label(root, key, fallback) {
    return (root.getAttribute(key) || '').trim() || fallback;
  }

  function cartAddUrl() {
    try {
      if (window.theme && theme.routes && theme.routes.cart_add_url) {
        return theme.routes.cart_add_url + '.js';
      }
    } catch (e) {}
    return '/cart/add.js';
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bag = document.querySelector('.cart-icon--bag');
        if (!bag) { return; }
        Array.prototype.forEach.call(bag.querySelectorAll('div'), function (el) {
          if (/^\s*\d+\s*$/.test(el.textContent)) { el.textContent = cart.item_count; }
        });
      })
      .catch(function () {});
  }

  function notifyTheme(originEl, message) {
    try {
      if (window.theme && theme.showQuickPopup && theme.jQuery) {
        theme.showQuickPopup((theme.strings && theme.strings.popupWasAdded) || message, theme.jQuery(originEl));
      }
    } catch (e) {}
  }

  function addToCart(sizeBtn, feedbackEl, addedLabel, errorLabel) {
    if (sizeBtn.classList.contains('is-busy')) { return; }
    sizeBtn.classList.add('is-busy');
    if (feedbackEl) { feedbackEl.textContent = ''; }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(sizeBtn.getAttribute('data-variant-id')), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) { throw new Error(data.description || data.message || errorLabel); }
          return data;
        });
      })
      .then(function () {
        if (feedbackEl) { feedbackEl.textContent = addedLabel; }
        refreshCartCount();
        notifyTheme(sizeBtn, addedLabel);
      })
      .catch(function (err) {
        if (feedbackEl) { feedbackEl.textContent = (err && err.message) ? err.message : errorLabel; }
      })
      .then(function () {
        sizeBtn.classList.remove('is-busy');
      });
  }

  function initCarousel(root) {
    if (root.getAttribute('data-fiori-init') === 'true') { return; }
    root.setAttribute('data-fiori-init', 'true');

    var addedLabel = label(root, 'data-added-label', 'Added to bag');
    var errorLabel = label(root, 'data-error-label', 'Could not add');

    var track = root.querySelector('[data-fiori-track]');
    var prev = root.querySelector('[data-fiori-prev]');
    var next = root.querySelector('[data-fiori-next]');
    var thumb = root.querySelector('[data-fiori-thumb]');

    if (track) {
      var step = function () {
        var item = track.querySelector('.fiori-carousel__item');
        if (!item) { return track.clientWidth; }
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      };

      var update = function () {
        var max = track.scrollWidth - track.clientWidth;

        // Everything fits: drop the arrows and progress bar, let cards fill the row.
        var isStatic = max <= 2;
        if (isStatic) {
          root.classList.add('fiori-carousel--static');
        } else {
          root.classList.remove('fiori-carousel--static');
        }

        if (prev) { prev.disabled = track.scrollLeft <= 1; }
        if (next) { next.disabled = track.scrollLeft >= max - 1; }

        if (thumb) {
          var ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
          var width = Math.min(Math.max(ratio * 100, 8), 100);
          thumb.style.width = width + '%';
          var progress = max > 0 ? track.scrollLeft / max : 0;
          var travel = 100 - width;
          var shift = width > 0 ? (progress * travel) / width * 100 : 0;
          thumb.style.transform = 'translateX(' + shift + '%)';
        }
      };

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) {
        try { new ResizeObserver(update).observe(track); } catch (e) {}
      }
      update();
      // Images settle late; re-measure once they have.
      window.addEventListener('load', update);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-fiori-buy]'), function (buy) {
      var addBtn = buy.querySelector('[data-fiori-add]');
      var form = buy.querySelector('form');
      var feedback = buy.querySelector('[data-fiori-feedback]');

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var open = buy.getAttribute('data-open') === 'true';
          buy.setAttribute('data-open', open ? 'false' : 'true');
          addBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      }

      // Keep the submit inside this card: stop it reaching the theme's global
      // cart handler, which would try its own add and fail on the missing id.
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      Array.prototype.forEach.call(buy.querySelectorAll('[data-fiori-size]'), function (sizeBtn) {
        sizeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (sizeBtn.disabled) { return; }
          addToCart(sizeBtn, feedback, addedLabel, errorLabel);
        });
      });
    });
  }

  function initAll(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-fiori-carousel]'), initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
